import type { DevBadgeView } from "./DevBadgeView";
import type { DevToolsConfig } from "./DevToolsConfig";

export class DevBadgePresenter {
  private readonly panel: DevBadgeView;
  private readonly cfg: DevToolsConfig;

  public constructor(input: { panel: DevBadgeView; config: DevToolsConfig }) {
    this.panel = input.panel;
    this.cfg = input.config;
  }

  public start(): void {
    this.panel.setText(this.cfg.badgeText);
    this.panel.setVisible(this.cfg.enabled);
  }

  public stop(): void {
    this.panel.setVisible(false);
  }
}